<template>
  <div>
    <v-layout wrap class="fullWindowHeight">
      <v-flex xs12 sm6>
        <v-layout wrap align-center justify-center class="fullWindowHeight">
          <v-flex xs8 style="padding-bottom: 10vh">
            <h1>{{ $t('a') }}</h1>
            <div>{{ $t('b') }}</div>
            <div v-if="!isEmailDomainOfAnExistingCompany" class="mt-8">
              <v-form @submit.prevent="checkIfIsEmailAddressOkToCreateAccount">
                <v-text-field v-model="email" :disabled="isEmailServerCheckPending" outlined type="email" :label="$t('c')" :rules="[emailRules]"/>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-btn type="submit" class="secondary" :disabled="isEmailServerCheckPending" >{{ $t('1') }}</v-btn>
                    <v-progress-linear v-if="isEmailServerCheckPending" indeterminate color="primary" class="mt-3"></v-progress-linear>
                  </v-flex>
                  <v-flex xs6 pt-2 text-end>
                    <router-link :to="'/consultant'" style="text-decoration: none"><small>{{ $t('n') }}</small></router-link>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
            <div v-else>
              <v-form ref="form" @submit.prevent="signup" v-model="isFormValid" class="mt-8">
                <v-text-field v-model="email" outlined type="email" :label="$t('c')" disabled/>
                <v-text-field v-model="password" autofocus outlined type="password" :label="$t('d')" :rules="[passwordRules]" />
                <v-layout wrap>
                  <v-flex xs6>                  
                    <v-btn type="submit" class="secondary" :disabled="(isPending || !isFormValid) && !formHasNotBeenTouchedYet">{{ $t('e') }}</v-btn>
                    <div v-if="errorMessage" class="red--text mt-5">{{errorMessage}}</div>
                  </v-flex>
                  <v-flex xs6 pt-2>
                    <router-link :to="'/consultant'" style="text-decoration: none"><small>{{ $t('n') }}</small></router-link>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
            <div style="position: absolute; bottom: 10px"><small>{{ $t('l') }} <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FCGU%20ESN%20Web%20Services.pdf?alt=media&token=e888057c-0e79-4bd7-bdbd-05afc66c13f9">{{ $t('m') }}</a>.</small></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 class="greyBackground">
        <v-layout wrap class="fullWindowHeight" align-center>
          <v-flex xs12 text-center style="padding-bottom: 5vh">
            <img :src="images.main" :height="$vuetify.breakpoint.xs ? null : '370px'">
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isPending" width="50%" persistent>
      <v-card class="pa-6">
        <v-progress-linear indeterminate color="primary" class="mt-1"></v-progress-linear>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";
const bannedEmailDomains = require('@/assets/app/data/bannedEmailDomains.json')

export default {
  data: () => ({
    email: null,
    password: null,
    isFormValid: false,
    errorMessage: '',
    isPending: false,
    images: {
      main: require('@/assets/app/images/dream_flatline.svg')
    },
    formHasNotBeenTouchedYet: true,
    isEmailDomainOfAnExistingCompany: false,
    isEmailServerCheckPending: false
  }),
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  methods: {
    async checkIfIsEmailAddressOkToCreateAccount() {
      if (this.emailRules(this.email) !== true) return;
      this.isEmailServerCheckPending = true

      // Check that user is not consultant
      const { isUserExisting, isConsultant } = (await this.$functions.httpsCallable('isUserExisting')({ email: this.email })).data
      if (isUserExisting && isConsultant) {
        const urlBase = `${window.location.hostname === 'localhost' ? 'http' : 'https'}://${window.location.host}`
        const url = new URL(`${urlBase}/consultant`)
        if (this.email) url.searchParams.set('email', this.email);
        if (this.$route.query.lang) url.searchParams.set('lang', this.$route.query.lang);
        return this.$router.push(url.href.replace(urlBase, ''));
      }

      // Check that at least one company accepts the email address' domain
      const url = `https://europe-west1-${process.env.VUE_APP_projectId}.cloudfunctions.net/getNbOfCompaniesWithThisEmailDomain`
      const { nbOfCompaniesWithThisEmailDomain } = (await axios({ method : 'POST', url, data: { email: this.email } })).data
      if (nbOfCompaniesWithThisEmailDomain === 0) {
        this.$router.push({ path: '/book-demo', query: { lang: this.$route.query.lang } })
      } else {
        this.isEmailDomainOfAnExistingCompany = true
        this.isEmailServerCheckPending = false
      }
    },
    emailRules(v) {
      if (!v) return this.$t('f')
      if (!/.+@.+\..+/.test(v)) return this.$t('g')
      if (!v || bannedEmailDomains.includes(v.split('@')[1])) return this.$t('k');
      return true
    },
    passwordRules(v) {
      if (!v) return this.$t('h')
      if (!v || v.length < 6 ) return this.$t('i')
      return true
    },
    signup() {
      if (this.formHasNotBeenTouchedYet) return;
      this.isPending = true
      this.errorMessage = '';
      const accountLocale = this.$route.query.lang || 'fr'
      this.$auth.createUserWithEmailAndPassword(this.email, this.password)
        .then(async () => {
          this.redirectWhenUserDataIsLoaded(accountLocale)
        })
        .catch(err => {
          this.errorMessage = err.message;
          if (err.code === 'auth/email-already-in-use') this.errorMessage = this.$t('j')
          this.isPending = false
        });
    },
    async redirectWhenUserDataIsLoaded(accountLocale) {
      if (this.user.loggedIn && this.user.data && this.user.data.createdAt) {
        await this.$functions.httpsCallable('setUpIsConsultantOrNot')({
          isConsultant: false
        })
        await this.$functions.httpsCallable('updateUser')({
          locale: accountLocale
        })
        return this.$router.push('/onboarding/verify-email-address-send-email').catch(error => console.info(error.message))
      } else {
        setTimeout(() => this.redirectWhenUserDataIsLoaded(accountLocale), 100)
      }
    },
  },
  watch: {
    email: {
      handler() {
        this.formHasNotBeenTouchedYet = false
      }
    },
    password: {
      handler() {
        this.formHasNotBeenTouchedYet = false
      }
    }
  }
};
</script>



<i18n>
{
  "fr": {
    "a": "Créez votre compte",
    "b": "... et soyez débarassé des heures de copier-coller sur Word.",
    "c": "Adresse email professionnelle",
    "d": "Mot de passe",
    "e": "Créer votre compte",
    "f": "Votre adresse email est requise.",
    "g": "Votre adresse email doit être au bon format.",
    "h": "Votre mot de passe est requis.",
    "i": "Votre mot de passe doit contenir au moins 6 caractères.",
    "j": "Cette adresse email est déjà utilisée par un compte existant.",
    "k": "Votre adresse email doit avoir le nom de domaine de votre ESN.",
    "l": "En créant votre compte, vous acceptez nos",
    "m": "Conditions Générales d'Utilisation",
    "n": "Vous êtes un consultant ?",

    "1": "Suivant"
  },
  "en": {
    "a": "Create your account",
    "b": "... and free yourself from hours of copy-pasting in Word.",
    "c": "Your professional email address",
    "d": "Password",
    "e": "Create account",
    "f": "Your email address is required.",
    "g": "Your email address must be in an appropriate format.",
    "h": "Your password is required.",
    "i": "Your password must contain at least 6 characters.",
    "j": "This email address is already used by an existing account.",
    "k": "Your email address must have the domain name of your company.",
    "l": "By signing up, you confirm that you've read and accepted our",
    "m": "Terms of Service",
    "n": "You are a consultant ?",

    "1": "Next"
  }
}
</i18n>